export const DEFAULT_TILE_SIZE = 512;
export const DEFAULT_TILE_RESOLUTION = 0.5;
export const DEFAULT_AGGREGATION_RES_LEVEL_H3 = 4;
export const DEFAULT_AGGREGATION_RES_LEVEL_QUADBIN = 6;
